module.exports = __webpack_public_path__ + "static/media/strongher10.10031e6e.jpg";